import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Icon,
  Button,
  CircularProgress,
} from '@material-ui/core';

import useStyles from './styles';

const ConfirmationDialog = props => {
  const classes = useStyles(props);
  const {
    type,
    icon,
    title,
    description,
    confirmText,
    cancelText,
    confirmCb,
    cancelCb,
    isOpen,
    loading,
  } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(typeof isOpen !== 'undefined' ? isOpen : false);
  }, [isOpen]);

  const handleConfirm = useCallback(() => {
    confirmCb();
  }, [confirmCb]);

  const handleCancel = useCallback(() => {
    cancelCb();
  }, [cancelCb]);

  return (
    <Dialog
      className={`${classes.container} ${type}`}
      open={open}
      maxWidth="xs"
    >
      <Box className="confirmation-title-container">
        <Icon className="confirmation-title-icon">{icon}</Icon>
        <Typography variant="h6" className="confirmation-title-text">
          {title}
        </Typography>
      </Box>
      <DialogContent>
        <Typography variant="body2" className="confirmation-description-text">
          {description}
        </Typography>
      </DialogContent>
      <DialogActions>
        {!loading && cancelText && cancelCb && (
          <Button className="confirmation-action-cancel" onClick={handleCancel}>
            {cancelText}
          </Button>
        )}
        {confirmText && confirmCb && (
          <Button
            className="confirmation-action-confirm"
            onClick={handleConfirm}
            autoFocus
          >
            {loading ? (
              <CircularProgress color="inherit" size={24} />
            ) : (
              confirmText
            )}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
